import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Route, Link, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ExitToApp } from '@mui/icons-material';
import { Button } from '@mui/material';
import axios from 'axios';
import { apiUrl } from '../../../utils/apiUrl';
import { useDispatch } from 'react-redux';
import { authAdmin } from '../../../redux/actions/user/authAdmin';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';

const drawerWidth = 240;
const getTitlePage = (path) => {
  switch (path) {
    case '/admin/page/create':
      return 'Новая страница';
    case '/admin/news/create':
      return 'Новая новость';
    case '/admin/game/create':
      return 'Новая игра';
    case '/admin/pages':
      return 'Вложениые игры';
    case '/admin/parent-games':
      return 'Вложенные игры';
    case '/admin/games':
      return 'Игры';
    case '/admin/tournaments':
      return 'Турниры';
    default:
      {
        if (path.slice(0, 20) === '/admin/game/update/') {
          return 'Редактирование игры';
        }
        if (path.slice(0, 19) === '/admin/page/update/') {
          return 'Редактирование страницы';
        }
        if (path.slice(0, 19) === '/admin/news/update/') {
          return 'Редактирование новости';
        }
      }
      break;
  }
};
const AdminLayout = (props) => {
  const { window, children } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    authAdmin: { data: authData, error: authError },
  } = useSelector((state) => state.user);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  React.useEffect(() => {
    dispatch(authAdmin());
  }, []);
  const menu = [
    {
      label: 'Пользователи',
      path: '/admin/users',
    },
    {
      label: 'Клубы',
      path: '/admin/clubs',
    },
    {
      label: 'Лиги',
      path: '/admin/leagues',
    },
    {
      label: 'Посты',
      path: '/admin/posts',
    },
    {
      label: 'Комментарии',
      path: '/admin/comments',
    },
    {
      label: 'Турниры',
      path: '/admin/tournaments',
    },
    {
      label: 'Товары',
      path: '/admin/products',
    },
    {
      label: 'Акции',
      path: '/admin/promotions',
    },
    {
      label: 'Страны',
      path: '/admin/countries',
    },
    {
      label: 'Упражнения',
      path: '/admin/exercises',
    },
    {
      label: 'Города',
      path: '/admin/city/list',
    },
  ];
  const drawer = (
    <div>
      <Toolbar>
        <svg width="181" height="20" viewBox="0 0 181 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: 'scale(1.1)' }}>
          <rect x="0.5" width="20" height="20" rx="10" fill="white" />
          <rect x="0.5" width="20" height="20" rx="10" fill="url(#paint0_linear_2147_6748)" />
          <path d="M14.2971 14.9361C14.815 14.9361 15.2349 14.5162 15.2349 13.9983C15.2349 13.4804 14.815 13.0605 14.2971 13.0605C13.7792 13.0605 13.3594 13.4804 13.3594 13.9983C13.3594 14.5162 13.7792 14.9361 14.2971 14.9361Z" fill="white" />
          <path
            d="M13.2531 11.5267L11.8236 10.0274L12.1779 9.64957L14.9812 6.63272C15.5351 6.03651 15.1124 5.06641 14.2985 5.06641C14.043 5.06641 13.7985 5.17132 13.6226 5.35688L10.5039 8.64342L7.57643 5.57341C7.41374 5.27184 7.09507 5.06664 6.72834 5.06664C6.72464 5.06664 6.72117 5.0671 6.71748 5.0671C6.69206 5.06664 6.66687 5.06918 6.64168 5.07103C6.63729 5.07149 6.63267 5.07149 6.62828 5.07195C6.19822 5.10708 5.80699 5.438 5.77094 5.92813C5.77048 5.93229 5.77048 5.93645 5.77002 5.94038C5.76886 5.96049 5.76562 5.97967 5.76562 6.00023V6.02935V6.04298V13.9732C5.76562 13.9767 5.76632 13.9799 5.76632 13.9834C5.75754 14.4691 6.13282 14.938 6.69922 14.938H6.74197C6.74983 14.938 6.75745 14.9371 6.76508 14.9369C6.77317 14.9366 6.78149 14.9362 6.78958 14.9357C7.02621 14.9235 7.25013 14.8229 7.4149 14.6508L10.5399 11.3885L11.9775 12.8855C12.5737 13.4394 13.5436 13.0168 13.5436 12.2029C13.5436 11.9471 13.4387 11.7028 13.2531 11.5267ZM7.69128 11.6071V8.42203L9.21161 10.0052L7.69128 11.6071Z"
            fill="white"
          />
          <path
            d="M32.674 9.52L37.516 16H34.654L30.154 10.096V16H27.67V3.4H30.154V8.962L34.474 3.4H37.336L32.674 9.52ZM39.7882 5.92C39.4042 5.92 39.0682 5.782 38.7802 5.506C38.5042 5.218 38.3662 4.882 38.3662 4.498C38.3662 4.114 38.5042 3.778 38.7802 3.49C39.0682 3.202 39.4042 3.058 39.7882 3.058C40.1842 3.058 40.5202 3.202 40.7962 3.49C41.0842 3.778 41.2282 4.114 41.2282 4.498C41.2282 4.882 41.0842 5.218 40.7962 5.506C40.5202 5.782 40.1842 5.92 39.7882 5.92ZM40.9582 16H38.6362V7H40.9582V16ZM47.6555 11.446L51.3815 16H48.6815L45.4055 11.914V16H43.0835V3.4H45.4055V10.96L48.5015 7H51.2735L47.6555 11.446ZM54.0849 9.556C54.0849 9.94 54.6309 10.27 55.7229 10.546C56.1069 10.63 56.4549 10.732 56.7669 10.852C57.0789 10.96 57.3909 11.122 57.7029 11.338C58.0269 11.542 58.2789 11.818 58.4589 12.166C58.6389 12.514 58.7289 12.916 58.7289 13.372C58.7289 14.296 58.3809 15.01 57.6849 15.514C56.9889 16.006 56.1309 16.252 55.1109 16.252C53.2629 16.252 52.0029 15.538 51.3309 14.11L53.3469 12.976C53.6229 13.756 54.2109 14.146 55.1109 14.146C55.9389 14.146 56.3529 13.888 56.3529 13.372C56.3529 12.988 55.8069 12.658 54.7149 12.382C54.3069 12.274 53.9589 12.166 53.6709 12.058C53.3829 11.95 53.0709 11.794 52.7349 11.59C52.3989 11.374 52.1409 11.104 51.9609 10.78C51.7929 10.444 51.7089 10.054 51.7089 9.61C51.7089 8.722 52.0329 8.026 52.6809 7.522C53.3409 7.006 54.1569 6.748 55.1289 6.748C55.8609 6.748 56.5269 6.916 57.1269 7.252C57.7269 7.576 58.2009 8.044 58.5489 8.656L56.5689 9.736C56.2809 9.124 55.8009 8.818 55.1289 8.818C54.8289 8.818 54.5769 8.89 54.3729 9.034C54.1809 9.166 54.0849 9.34 54.0849 9.556ZM66.9391 8.062V7H69.2611V16H66.9391V14.938C66.2431 15.814 65.2651 16.252 64.0051 16.252C62.8051 16.252 61.7731 15.796 60.9091 14.884C60.0571 13.96 59.6311 12.832 59.6311 11.5C59.6311 10.18 60.0571 9.058 60.9091 8.134C61.7731 7.21 62.8051 6.748 64.0051 6.748C65.2651 6.748 66.2431 7.186 66.9391 8.062ZM62.6551 13.336C63.1231 13.804 63.7171 14.038 64.4371 14.038C65.1571 14.038 65.7511 13.804 66.2191 13.336C66.6991 12.856 66.9391 12.244 66.9391 11.5C66.9391 10.756 66.6991 10.15 66.2191 9.682C65.7511 9.202 65.1571 8.962 64.4371 8.962C63.7171 8.962 63.1231 9.202 62.6551 9.682C62.1871 10.15 61.9531 10.756 61.9531 11.5C61.9531 12.244 62.1871 12.856 62.6551 13.336ZM76.6047 6.748C77.8167 6.748 78.8487 7.21 79.7007 8.134C80.5647 9.058 80.9967 10.18 80.9967 11.5C80.9967 12.844 80.5647 13.972 79.7007 14.884C78.8607 15.796 77.8287 16.252 76.6047 16.252C75.3447 16.252 74.3727 15.814 73.6887 14.938V19.6H71.3667V7H73.6887V8.062C74.3727 7.186 75.3447 6.748 76.6047 6.748ZM74.3907 13.336C74.8587 13.804 75.4527 14.038 76.1727 14.038C76.8927 14.038 77.4867 13.804 77.9547 13.336C78.4347 12.856 78.6747 12.244 78.6747 11.5C78.6747 10.756 78.4347 10.15 77.9547 9.682C77.4867 9.202 76.8927 8.962 76.1727 8.962C75.4527 8.962 74.8587 9.202 74.3907 9.682C73.9227 10.15 73.6887 10.756 73.6887 11.5C73.6887 12.244 73.9227 12.856 74.3907 13.336ZM87.8723 6.748C89.0843 6.748 90.1163 7.21 90.9683 8.134C91.8323 9.058 92.2643 10.18 92.2643 11.5C92.2643 12.844 91.8323 13.972 90.9683 14.884C90.1283 15.796 89.0963 16.252 87.8723 16.252C86.6123 16.252 85.6403 15.814 84.9563 14.938V19.6H82.6343V7H84.9563V8.062C85.6403 7.186 86.6123 6.748 87.8723 6.748ZM85.6583 13.336C86.1263 13.804 86.7203 14.038 87.4403 14.038C88.1603 14.038 88.7543 13.804 89.2223 13.336C89.7023 12.856 89.9423 12.244 89.9423 11.5C89.9423 10.756 89.7023 10.15 89.2223 9.682C88.7543 9.202 88.1603 8.962 87.4403 8.962C86.7203 8.962 86.1263 9.202 85.6583 9.682C85.1903 10.15 84.9563 10.756 84.9563 11.5C84.9563 12.244 85.1903 12.856 85.6583 13.336Z"
            fill="black"
          />
          <defs>
            <linearGradient id="paint0_linear_2147_6748" x1="19.7479" y1="10.3946" x2="0.751942" y2="9.55032" gradientUnits="userSpaceOnUse">
              <stop offset="0.317708" />
              <stop offset="1" stop-color="#737373" />
            </linearGradient>
          </defs>
        </svg>
      </Toolbar>
      <Divider />
      <List>
        {menu?.map((item) => (
          <ListItem key={1} disablePadding>
            <ListItemButton
              onClick={() => {
                navigate(item.path);
              }}
              selected={location.pathname == item?.path}>
              <ListItemText primary={item?.label} />
            </ListItemButton>
          </ListItem>
        ))}
        {/* <ListItem key={1} disablePadding>
          <ListItemButton
            onClick={() => {
              navigate('/admin/orders');
            }}
            selected={location.pathname == '/admin/orders'}>
            <ListItemText primary={'Покупки'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={1} disablePadding>
          <ListItemButton
            onClick={() => {
              navigate('/admin/banners');
            }}
            selected={location.pathname == '/admin/banners'}>
            <ListItemText primary={'Баннеры'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={2} disablePadding>
          <ListItemButton
            onClick={() => {
              navigate('/admin/support-list');
            }}
            selected={location.pathname == '/admin/support-list'}>
            <ListItemText primary={'Поддержка'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={3} disablePadding>
          <ListItemButton
            onClick={() => {
              navigate('/admin/games');
            }}
            selected={location.pathname == '/admin/games'}>
            <ListItemText primary={'Игры'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={4} disablePadding>
          <ListItemButton
            onClick={() => {
              navigate('/admin/parent-games');
            }}
            selected={location.pathname == '/admin/parent-games'}>
            <ListItemText primary={'Вложенные игры'} />
          </ListItemButton>
        </ListItem>
      */}
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    authData && (
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <ToastContainer theme="colored" />
        <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}>
          <Toolbar>
            <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2, display: { sm: 'none' } }}>
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div">
              {getTitlePage(location.pathname)}
            </Typography>
            <Button
              onClick={() => {
                localStorage.removeItem('token');
                navigate('/');
              }}
              variant="contained"
              color="error"
              sx={{ boxShadow: 'none !important', ml: 'auto', color: 'white' }}
              endIcon={<ExitToApp sx={{ color: 'white' }} />}>
              Выход
            </Button>
          </Toolbar>
        </AppBar>
        <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }} aria-label="mailbox folders">
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}>
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
            open>
            {drawer}
          </Drawer>
        </Box>
        <Box component="main" sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}>
          <Toolbar></Toolbar>
          {children}
        </Box>
      </Box>
    )
  );
};

export default AdminLayout;
